import { render } from "./Pos.vue?vue&type=template&id=0795d3de"
import script from "./Pos.vue?vue&type=script&lang=js"
export * from "./Pos.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wServer\\app-pagos-elroble\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__